// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"4324927b","381":"43e12abf","453":"28dcd6da","603":"848cce14","862":"3ecf7af4"}[chunkId] + ".chunk.js";
};